import React, { useEffect, useRef } from 'react';
import { LuInfo } from 'react-icons/lu';
import Button from '../common/Button';
import { STRINGS } from '../../constants/strings';

/**
 * Explains that an action (editing a student, adding staff) is done in the SchoolLine app,
 * not on the dashboard. A native <dialog>: Esc and a click outside close it.
 */
const UnsupportedFeatureDialog = ({ isOpen, onClose, feature = "feature" }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;

    if (isOpen && dialog) {
      dialog.showModal();
    } else if (dialog) {
      dialog.close();
    }
  }, [isOpen]);

  // Close when clicking on the backdrop (outside the dialog content)
  const handleBackdropClick = (event) => {
    if (event.target === dialogRef.current) {
      onClose();
    }
  };

  return (
    <dialog
      ref={dialogRef}
      onClick={handleBackdropClick}
      onClose={onClose}
      aria-label={STRINGS.DIALOGS.UNSUPPORTED_FEATURE.TITLE}
      className="m-auto w-full max-w-md rounded-xl border border-ui-line bg-ui-card p-0 text-ui-ink shadow-pop backdrop:bg-black/40"
    >
      <div className="p-6">
        <div className="flex items-start gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-300">
            <LuInfo aria-hidden className="size-5" />
          </div>
          <div className="min-w-0">
            <h2 className="text-base font-semibold text-ui-ink">{STRINGS.DIALOGS.UNSUPPORTED_FEATURE.TITLE}</h2>
            <p className="mt-0.5 text-sm text-ui-ink-2">{STRINGS.DIALOGS.UNSUPPORTED_FEATURE.SUBTITLE}</p>
            <p className="mt-3 text-sm leading-relaxed text-ui-ink-2">{STRINGS.DIALOGS.UNSUPPORTED_FEATURE.REASON_TEXT}</p>
          </div>
        </div>
        <div className="mt-6 flex justify-end">
          <Button variant="secondary" onClick={onClose} autoFocus>
            {STRINGS.DIALOGS.UNSUPPORTED_FEATURE.BUTTON_OK}
          </Button>
        </div>
      </div>
    </dialog>
  );
};

export default UnsupportedFeatureDialog;
